module.exports = __webpack_public_path__ + "img/face2.e483e1c4.png";